import { render, staticRenderFns } from "./ProductInvoice.vue?vue&type=template&id=04cdf558"
import script from "./ProductInvoice.vue?vue&type=script&lang=js"
export * from "./ProductInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports